export const MAIN_CONTENT_WIDTH = 1100;
